__turbopack_context__.v({
  "addonLogoPreload": "navbar-module__XTTUFG__addonLogoPreload",
  "caretIcon": "navbar-module__XTTUFG__caretIcon",
  "caretIconOpen": "navbar-module__XTTUFG__caretIconOpen",
  "container": "navbar-module__XTTUFG__container",
  "containerDropdownOpen": "navbar-module__XTTUFG__containerDropdownOpen",
  "containerHidden": "navbar-module__XTTUFG__containerHidden",
  "containerScrolled": "navbar-module__XTTUFG__containerScrolled",
  "drawerContainer": "navbar-module__XTTUFG__drawerContainer",
  "dropdownContainer": "navbar-module__XTTUFG__dropdownContainer",
  "endCluster": "navbar-module__XTTUFG__endCluster",
  "logoCompact": "navbar-module__XTTUFG__logoCompact",
  "logoContainer": "navbar-module__XTTUFG__logoContainer",
  "logoFull": "navbar-module__XTTUFG__logoFull",
  "logoLink": "navbar-module__XTTUFG__logoLink",
  "navLink": "navbar-module__XTTUFG__navLink",
  "navLinkDisabled": "navbar-module__XTTUFG__navLinkDisabled",
  "navList": "navbar-module__XTTUFG__navList",
  "navListItem": "navbar-module__XTTUFG__navListItem",
  "navbar": "navbar-module__XTTUFG__navbar",
  "navbarCompact": "navbar-module__XTTUFG__navbarCompact",
  "spacer": "navbar-module__XTTUFG__spacer",
  "techLogoPreload": "navbar-module__XTTUFG__techLogoPreload",
  "themeToggleContainer": "navbar-module__XTTUFG__themeToggleContainer",
});
